import { Modal, ModalProps } from '@wix/design-system';
import React from 'react';
import { ModalState } from '@wix/bex-core';
import { observer } from 'mobx-react-lite';

export interface CollectionModalProps extends Partial<ModalProps> {
  state: ModalState;
}

export const CollectionModal = observer(function CollectionModal({
  state,
  ...rest
}: CollectionModalProps) {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal isOpen={state.isOpen} onRequestClose={state.close} {...rest} />
    </div>
  );
});
